import hatsApi from '@/services/hatsApi'

export default {
  getReservation (id) {
    return hatsApi().get('/operational/reservation/' + id)
  },
  getReservations (params, pageSize = '', page = '', sort = '') {
    let filter = params || []
    let pagination = ''
    let sorting = ''
    if (sort) {
      sorting = '&sort=' + sort
    }
    if (pageSize) {
      pagination += `&pageSize=${pageSize}`
    }
    if (page) {
      pagination += `&page=${page}`
    }
    return hatsApi().get(`/operational/reservation?filter=${JSON.stringify(filter)}${pagination}${sorting}`)
  },
  getNotes (params) {
    let filter = params || []
    return hatsApi().get('/operational/reservation-note?filter=' + JSON.stringify(filter))
  },
  createNote (params) {
    return hatsApi().post('/operational/reservation-note', params)
  },
  updateNote (params) {
    return hatsApi().put('/operational/reservation-note/' + params.id, { content: params.content })
  },
  deleteNote (id) {
    return hatsApi().delete('/operational/reservation-note/' + id, { data: { id: id } })
  },
  createReservation (params) {
    return hatsApi().post('/operational/reservation', params)
  },
  updateReservation (params) {
    return hatsApi().put('/operational/reservation/' + params.id, params)
  },
  deleteReservation (id) {
    return hatsApi().delete('/operational/reservation/' + id)
  },
  getTransportTypes (params) {
    let filter = params || []
    return hatsApi().get('/operational/reservation/transport-type?filter=' + JSON.stringify(filter))
  },
  getAccommodationTypes (params, passengers, reservationId, statusCode, selectedTypes, customRoomsAmount) {
    let filter = params || []
    return hatsApi().get('/operational/reservation/room-type?filter=' + JSON.stringify(filter) + '&passengers=' + JSON.stringify(passengers) + '&reservationId=' + reservationId + '&statusCode=' + statusCode + '&customRoomsAmount=' + customRoomsAmount)
  },
  getAutoBookingLogs (reservationId) {
    let filter = [{'property': 'reservationId', 'value': reservationId}]
    return hatsApi().get('/system/autobooking/logs?filter=' + JSON.stringify(filter))
  },
  getInsuranceLogs (reservationId) {
    let filter = [{'property': 'reservationId', 'value': reservationId}]
    return hatsApi().get('/system/hmrv_log?filter=' + JSON.stringify(filter))
  },
  getEmailLogs (reservationId) {
    let filter = [{'property': 'reservationId', 'value': reservationId}]
    return hatsApi().get('/operational/reservation_email?filter=' + JSON.stringify(filter))
  },
  preloadBeds (params) {
    return hatsApi().post('/operational/reservation/preload-beds', params)
  },
  getRollingStockCoupes (params) {
    let filter = params || []
    return hatsApi().get('/operational/reservation/rolling-stock-coupe?filter=' + JSON.stringify(filter))
  },
  getTimes (params) {
    let filter = params || []
    return hatsApi().get('/operational/reservation/transport-time?filter=' + JSON.stringify(filter))
  },
  priceCalculation (params) {
    return hatsApi().post('/operational/reservation/price-calculation', params)
  },
  generateTickets (id) {
    return hatsApi().put('/operational/reservation/ticket/' + id)
  },
  sendTickets (id, payload = {}) {
    return hatsApi().put(`/operational/reservation/email/${id}`, payload)
  },
  getTicketList (filter) {
    return hatsApi().get('/operational/reservation-ticket/?filter=' + JSON.stringify(filter))
  },
  getTicket (id) {
    return hatsApi().get('/operational/reservation-ticket/' + id, { 'responseType': 'blob' })
  },
  getDocumentsFile (id) {
    return hatsApi().get(`/operational/reservation/documents/${id}`, { 'responseType': 'blob' })
  },
  generateInvoice (reservationId) {
    return hatsApi().put(`/operational/reservation/invoice/${reservationId}`)
  },
  getInvoice (reservationId) {
    return hatsApi().get(`/operational/reservation-invoice/${reservationId}`, { 'responseType': 'blob' })
  },
  sendPaymentLink (reservationId, neededToPay) {
    return hatsApi().get('/operational/reservation/send-payment-link/' + reservationId + '?amount=' + neededToPay)
  },
  reservationsExport (params, lang) {
    let filters = params || []
    return hatsApi().get('/operational/reservation/export?filter=' + JSON.stringify(filters) + '&lang=' + lang)
  }
}



// WEBPACK FOOTER //
// ./src/services/hatsApi/Reservation.js